import { injectQuery } from '@tanstack/angular-query-experimental'
import { injectCartoClient } from '../services/carto.helper'
import { fetchTags } from '../services/tags.service'

export { type TagRow } from '../services/tags.service'

export function injectTagsQuery() {
  const cartoClient = injectCartoClient()

  return injectQuery(() => ({
    queryKey: ['tags'],
    queryFn: async ({ signal }) => {
      return fetchTags(cartoClient, signal)
    },
  }))
}
